import { useQuery } from '@tanstack/react-query'
import { integrationsApi } from '@/lib/api'

/** Hecate's integration health — refreshed in line with the 15-minute sweep. */
export function useIntegrations() {
  return useQuery({
    queryKey: ['integrations', 'health'],
    queryFn: () => integrationsApi.health(),
    staleTime: 60_000,
  })
}
